import { isDev } from "../reusable/utils";

const dbLocal = {
  apiKey: "AIzaSyBaPnwzYUSHYIIOoV81UruAVuVTBMXm4Hg",
  authDomain: "evolve-local.firebaseapp.com",
  databaseURL: "https://evolve-local.firebaseio.com",
  projectId: "evolve-local",
  storageBucket: "evolve-local.appspot.com",
  messagingSenderId: "295197769777"
};

const dbProd = {
  apiKey: "AIzaSyDX7zP-n2ObArNQMpew6zvjlJaPAvesfRw",
  authDomain: "evolve-f8968.firebaseapp.com",
  databaseURL: "https://evolve-f8968.firebaseio.com",
  projectId: "evolve-f8968",
  storageBucket: "evolve-f8968.appspot.com",
  messagingSenderId: "97425264362"
};

const labsProd = {
  client_id: "87n3tgiBFHWZU3XI6CVw3wsKgifBBFtfoNO758jv",
  redirect_uri: "https://us-central1-evolve-f8968.cloudfunctions.net/streamlabs-token"
};

const labsLocal = {
  client_id: "YptVxsMmih4pDX55d0LWG2IQTCB7ovufs3dRdyfo",
  redirect_uri: "https://us-central1-evolve-local.cloudfunctions.net/streamlabs-token"
};

export default {
  firebase: isDev ? dbLocal : dbProd,
  twitch: {
    client_id: "jo0960ninppwp90cl0d24miaa09qx8h"
  },
  streamlabs: isDev ? labsLocal : labsProd
};



// WEBPACK FOOTER //
// ./src/constants/config.js